<template>
  <div>
    <Breadtabsheader/>
    <div class="h-content">
      <div class="h-piece">
        <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder" ref="form">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="采购订单号" style="width: 25%;">
              <el-input v-model="formInline.orderCode" placeholder="请输入" ></el-input>
            </el-form-item>
            <el-form-item label="合同号" style="width: 25%;">
              <el-input v-model="formInline.contractCode" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="合同时间" prop="billNo" style="width: 28%;">
              <el-date-picker
                  style="width: 100%"
                  v-model="valueTime"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="changeTime"
              />
            </el-form-item>
          </div>
          <div class="l-screenBox">
            <div class="l-retrieval">
              <el-button @click="onSearch" class="h-btn h-formBtn">检索</el-button>
              <el-button @click="resetData" class="h-btn h-formBtn h-bgwhite">重置</el-button>
              <el-button v-auth="'createContract'" class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
                         @click="addNew">新增</el-button>
            </div>
          </div>
        </el-form>
      </div>
      <div class="h-table h-mrt30" >
        <el-table :data="tableData" border style="width: 100%" stripe max-height="450">
          <el-table-column label="采购订单号" prop="orderCode" width="230" show-overflow-tooltip></el-table-column>
          <el-table-column label="合同号" prop="contractCode" width="230" show-overflow-tooltip></el-table-column>
          <el-table-column label="合同名称" prop="contractName" width="230" show-overflow-tooltip></el-table-column>
          <el-table-column label="合同开始时间" prop="startDate"></el-table-column>
          <el-table-column label="合同结束时间" prop="endDate" ></el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button @click="handleUpdate(scope.row)" type="text">修改</el-button>
              <el-button @click="handleDel(scope.row)" type="text">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="h-tableB h-mrt30">
          <div class="h-pagination2">
            <pagination :page="formInline" @query="query"/>
          </div>
        </div>
      </div>
    </div>

<!--    新增、修改-->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" class="h-dialog2" >
      <div class="h-dialogImg">
        <div class="h-disTable">
          <div class="h-tableCell">
            <h1>{{title}}</h1>
          </div>
        </div>
      </div>
      <div class="h-formLines">
        <el-form ref="addForm" :model="addform" :inline="true" :rules="addRules" class="demo-ruleForm h-formbLine h-dialogForm">
          <el-form-item label="采购订单号" class="h-elformWrap-2" prop="orderCode" >
            <el-input placeholder="输入采购订单号" v-model="addform.orderCode" ></el-input>
          </el-form-item>
          <el-form-item label="合同号" class="h-elformWrap-2" prop="contractCode">
            <el-input placeholder="输入合同号" v-model="addform.contractCode"></el-input>
          </el-form-item>
          <el-form-item label="合同名称" class="h-elformWrap-2" prop="contractName" >
            <el-input placeholder="输入合同名称" v-model="addform.contractName"></el-input>
          </el-form-item>
          <el-form-item label="合同开始时间" class="h-elformWrap-2" prop="startDate">
            <el-date-picker v-model="addform.startDate" type="date" placeholder="请选择合同开始时间" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="合同结束时间" class="h-elformWrap-2" prop="endDate">
            <el-date-picker v-model="addform.endDate" type="date" placeholder="请选择合同结束时间" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <div style="display:flex;justify-content:center;margin-bottom:20px">
          <el-button class="h-btn h-bBtn h-bgwhite" @click="closeSpecific">取消</el-button>
          <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitSpecific()">提交</el-button>
        </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import orderTend from "@/api/loud/hetong/orderTend";
import moment from "moment";
export default {
  data() {
    // 自定义验证规则
    const validateDate = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请选择日期'))
      }

      if (rule.field === 'endDate' && this.addform.startDate) {
        const startDate = new Date(this.addform.startDate)
        const endDate = new Date(value)

        if (endDate < startDate) {
          return callback(new Error('结束时间不能早于开始时间'))
        }
      }

      if (rule.field === 'startDate' && this.addform.endDate) {
        const startDate = new Date(value)
        const endDate = new Date(this.addform.endDate)

        if (startDate > endDate) {
          return callback(new Error('开始时间不能晚于结束时间'))
        }
      }

      callback()
    }
    return {
      formInline:{
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      valueTime: [],
      tableData: [],
      title: '新增',
      dialogVisible: false,
      type: 'add',
      addform:{
        orderCode:'',
        contractCode:'',
        contractName:'',
        startDate:'',
        endDate:'',
      },
      addRules:{
        orderCode: [ {required: true, message: '请输入采购合同号', trigger: 'blur'},],
        contractCode: [ {required: true, message: '请输入合同号', trigger: 'blur'},],
        contractName: [ {required: true, message: '请输入合同名称', trigger: 'blur'},],
        startDate: [
            {required: true, message: '请选择合同开始时间', trigger: 'change'},
            { validator: validateDate, trigger: 'change' }
        ],
        endDate: [
            {required: true, message: '请选择合同结束时间', trigger: 'change'},
            { validator: validateDate, trigger: 'change' }
        ],
      }
    }
  },
  methods:{
    onSearch(){
      this.formInline.pageNo = 1;
      this.query();
    },
    resetData(){
      this.formInline = {
        pageNo: 1,
        pageSize: 10,
        total: 0
      }
      this.valueTime = [];
      this.query();
    },
    addNew(){
      this.title = '新增';
      this.dialogVisible = true;
      this.type = 'add'
      this.$nextTick(() => {
        if (this.$refs.addForm) {
          this.$refs.addForm.resetFields();
        }
      });
    },
    changeTime(date){
      if(date){
        this.formInline.startDate = moment(date[0]).format('YYYY-MM-DD');
        this.formInline.endDate = moment(date[1]).format('YYYY-MM-DD');
      }else{
        this.formInline.startDate = '';
        this.formInline.endDate = '';
      }
    },
    query(){
      orderTend.page(this.formInline).then(res => {
        this.formInline.total = res.total;
        this.tableData = res.records;
      })
    },
    handleUpdate(row){
      this.addform = row;
      this.dialogVisible = true;
      this.title = '修改';
      this.type = 'update';
    },
    handleDel(row){
      this.$msg.confirm("确认删除?", () => {
        orderTend.deleteById(row.id).then(rd => {
          this.$msg.msgs(rd.msg);
          this.query();
        })
      })
    },
    closeSpecific(){
      this.dialogVisible = false;
    },
    commitSpecific(){
      this.$refs.addForm.validate(valid => {
        if (valid) {
          if(this.type == 'add'){
            orderTend.insert(this.addform).then(res => {
              if(res.f == true){
                this.dialogVisible = false;
                this.query();
              }else{
                this.$msg.msgs(res.msg);
              }
            })
          }else if(this.type == 'update'){
            orderTend.updateById(this.addform).then(res => {
              if(res.f == true){
                this.dialogVisible = false;
                this.query();
              }else{
                this.$msg.msgs(res.msg);
              }
            })
          }
        }
      })
    }
  },
  mounted() {
    this.query();
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-date-editor .el-range-separator{
  padding: 0px 20px 0px 6px;
}
::v-deep .el-table tbody td .cell{
  padding: 0;
}
</style>
